import React from "react";

import FeatureToggles, {
    FeatureToggleKeys,
} from "@services/featureToggles.services";

import {
    ProductPageComponent,
    ProductPageComponentProps,
} from "./productPage.component";

export type ProductPageContainerProps = ProductPageComponentProps;

const ProductPageContainer = ({
    product,
    defaultVideoThumbnailPath,
    brandPagePath,
    sliders,
    cashbackPagePath,
    contextAwareXfPath,
    tooltips,
    edlpimage,
    infoLink,
    promoBannerHTML,
    paramsAlgolia,
    maxVisibleFeatures,
    infocardLinks,
    reviewsEnabled,
}: ProductPageContainerProps) => {
    return (
        <ProductPageComponent
            product={product}
            brandPagePath={brandPagePath}
            defaultVideoThumbnailPath={defaultVideoThumbnailPath}
            sliders={sliders}
            cashbackPagePath={cashbackPagePath}
            contextAwareXfPath={contextAwareXfPath}
            edlpimage={edlpimage}
            tooltips={tooltips}
            paramsAlgolia={paramsAlgolia}
            infoLink={infoLink}
            promoBannerHTML={promoBannerHTML}
            maxVisibleFeatures={maxVisibleFeatures}
            infocardLinks={infocardLinks}
            reviewsEnabled={
                reviewsEnabled ||
                FeatureToggles.isEnabled(FeatureToggleKeys.REVIEWS)
            }
        />
    );
};

export { ProductPageContainer };
